import { Comment, Discussion, Identifiable } from "@planzone/dto";
import { HttpClient, HttpMethods } from "@planzone/services";

function isDateValid(date: string) {
  return !isNaN(new Date(date).valueOf());
}

function saveComment(httpClient: HttpClient) {
  return (
    discussion: Identifiable<Discussion>,
    { recipients, replyTo, ...comment }: Comment,
  ) =>
    httpClient
      .sendHttpRequest<Identifiable<Comment>>({
        endpoint: "/comments/create",
        method: HttpMethods.POST,
        headers: {
          element_name: "Element",
          list_name: "List",
        },
        data: {
          ...comment,
          author: `/resources/${comment.author.uuid}`,
          ...(!!discussion.uuid && {
            discussion: `/discussions/${discussion.uuid}`,
          }),
          recipientsIds: recipients.map(({ uuid }) => uuid),
          ...(replyTo && { replyToUuid: replyTo.uuid }),
        },
      })
      .then((savedComment) => ({
        ...savedComment,
        author: comment.author,
        createdDate: isDateValid(savedComment.createdDate)
          ? savedComment.createdDate
          : new Date().toISOString(),
        recipients,
        ...(replyTo && { replyTo }),
      }));
}

export { saveComment };
